// PROD-9606 F6: plan-category labels for Care's screens (VD-16). A row without a category reads by its high-volume flag.

export const PLAN_CATEGORY_LEGACY = 'legacy';
export const PLAN_CATEGORY_CONSISTENCY = 'consistency';
export const PLAN_CATEGORY_CONSISTENCY_RECORDING = 'consistency_recording';

export type PlanCategory = 'legacy' | 'consistency' | 'consistency_recording';

type Categorised =
  { plan_category?: string | null; is_high_volume?: number | string | null } | null | undefined;

const LABELS: Record<PlanCategory, string> = {
  legacy: 'Legacy Regular',
  consistency: 'Consistency',
  consistency_recording: 'Consistency + Recording'
};

export function isPlanCategory(value: unknown): value is PlanCategory {
  return (
    value === PLAN_CATEGORY_LEGACY ||
    value === PLAN_CATEGORY_CONSISTENCY ||
    value === PLAN_CATEGORY_CONSISTENCY_RECORDING
  );
}

// The stored category, else the old flag: high-volume rows are Consistency, the rest Legacy.
export function planCategoryOf(pkg: Categorised): PlanCategory {
  if (pkg && isPlanCategory(pkg.plan_category)) return pkg.plan_category;
  return Number(pkg?.is_high_volume) === 1 ? PLAN_CATEGORY_CONSISTENCY : PLAN_CATEGORY_LEGACY;
}

// The label Care sees beside a package; empty for an unknown value so callers can skip the suffix.
export function categoryLabel(category: unknown): string {
  return isPlanCategory(category) ? LABELS[category] : '';
}

export function includesRecordings(category: unknown): boolean {
  return category === PLAN_CATEGORY_CONSISTENCY_RECORDING;
}

export function isConsistency(category: unknown): boolean {
  return category === PLAN_CATEGORY_CONSISTENCY;
}

// The dropdown label Care sees for a package: its name, then its category (VD-16).
export function packageOptionLabel(pkg: { name: string } & NonNullable<Categorised>): string {
  const label = categoryLabel(planCategoryOf(pkg));
  return label ? `${pkg.name} · ${label}` : pkg.name;
}
